import * as types from './meeting-folder.types';
export const meetingsFoldersPageSelectors: types.IMeetingFoldersSelectors = {
  selectMeetingFoldersIds: (state) => state.page.meetingFolders.meetingFoldersIds,
};
